import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

import { Grid, TextField, Paper, Typography, MenuItem, InputLabel, FormControl, Select, Autocomplete, Button, Skeleton, Box } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { fetchErrorMessages, selectErrorMessagesByKeyName } from "../../../reducers/reference_errormessages";
import { createProfileAddress, updateProfileAddress, updateProfileDemographics } from "../../../reducers/profile";

import { selectGlobalSettingEntities } from "../../../reducers/reference_settings";
import { selectViewInstanceById, viewinstanceClear } from "../../../reducers/reuseable_vi";

//import { getPWRequest } from "../actions/viewinstance";

const ProfileDemographics = (props) => {
  const navigate = useNavigate()
  const [callVI, setCallVI] = useState(false)
  //  const { viewInstance, settings } = useSelector(state => state.viewinstance)
  const { user: currentUser } = useSelector((state) => state.auth);
  const viewInstance = useSelector(state => selectViewInstanceById(state, "ProfileDemographics"))
  const settings = useSelector(state => selectGlobalSettingEntities(state))
  const errormessageStatus = useSelector(state => state.errormessages.status)
  const [timer, setTimer] = useState(null);
  const FirstNameError = useSelector(state => selectErrorMessagesByKeyName(state, 'VAL FIRST NAME'))
  const LastNameError = useSelector(state => selectErrorMessagesByKeyName(state, 'VAL LAST NAME'))
  const EmailError = useSelector(state => selectErrorMessagesByKeyName(state, 'VAL EMAIL PROFILE'))
  const DobError = useSelector(state => selectErrorMessagesByKeyName(state, 'VAL DATEOFBIRTH'))
  const [paramData, setParamData] = useState({
    AuthToken: '',
    ParticipantGuid: '',
    GroupGuid: '',
    ParticipantGroupGuid: '~~',
    LanguageID: '',
    LastName: '',
    MiddleName: '~_~',
    FirstName: '',
    BioDOB: '',
    BioGender: '',
    BioRace: '',
    BioRace2: '~_~',
    BioRace3: '~_~',
    Email: '',
    SpokenLanguageID: '',
    EducationLevelGuid: '',
    ParticipantAddressGuid: '',
    ParticipantAddressTypeGuid: '',
    ZipCode: '',
    CountryCode: '',
    validLastName: true,
    validFirstName: true,
    validDoB: true,
    validGender: true,
    validRace: true,
    validEmail: true,
    validSpokenLanguage: true,
    validEducation: true,
    validZipCode: true,
    validCountry: true,
  })

  const dispatch = useDispatch()



  useEffect(() => {
    console.log({p:paramData, s:settings, v:viewInstance})
    if (settings && viewInstance && viewInstance.ProfileVI) {
      let educationGuid = viewInstance.ProfileVI.MenuProfile.ProfileEducationFrame.EducationSQL ?
        viewInstance.ProfileVI.MenuProfile.ProfileEducationFrame.EducationSQL[0]
        : {
          EducationTypeName: ""
          , EducationTypeId: ""
          , EducationTypeGuid: ""
        }

      let race = viewInstance.ProfileVI.MenuProfile.ProfileRaceFrame.RaceSQL ?
        viewInstance.ProfileVI.MenuProfile.ProfileRaceFrame.RaceSQL[0]
        : {
          RaceTypeId: "",
          RaceTypeName: ""
        }


      let language = viewInstance.ProfileVI.MenuProfile.ProfileLangSpeakFrame.LangSpeakTextValue ?
        viewInstance.ProfileVI.MenuProfile.ProfileLangSpeakFrame.LangSpeakDropdownList.find(option => option.LanguageTypeId === viewInstance.ProfileVI.MenuProfile.ProfileLangSpeakFrame.LangSpeakTextValue)
        : {
        LanguageTypeId: "",
        LanguageTypeName: "",
        StandardContent: ""
      }
      let country = 
      viewInstance.ProfileVI.MenuProfile.ProfileAddressFrame.AddressSQL ?
      viewInstance.ProfileVI.MenuProfile.ProfileAddressFrame.ProfileAddressCountryFrame.CountryDropdownList.find(country => country.CountryId === viewInstance.ProfileVI.MenuProfile.ProfileAddressFrame.AddressSQL[0].CountryId)
        : {
        CountryName: "",
        StandardContent: "",
        CountryId: ""
      }

      let zipcode = viewInstance.ProfileVI.MenuProfile.ProfileAddressFrame.AddressSQL[0].PostalCode === "UNSPECIFIED" ? "" : viewInstance.ProfileVI.MenuProfile.ProfileAddressFrame.AddressSQL[0].PostalCode
      let bgender = 
      viewInstance.ProfileVI.MenuProfile.ProfileGenderFrame.GenderTextValue ?
      viewInstance.ProfileVI.MenuProfile.ProfileGenderFrame.ProfileGenderLabels.find(bio => bio.GenderTypeId === viewInstance.ProfileVI.MenuProfile.ProfileGenderFrame.GenderTextValue) 
        : { GenderTypeName: "", GenderTypeId: "" }

        setParamData({
        ...paramData,
        AuthToken: currentUser.AuthToken,
        ParticipantGuid: settings.session['PERSON GUID'],
        GroupGuid: settings.session['ORGANIZATION GUID'],
        LanguageID: settings.session['LANGUAGE ID'],
        LastName: viewInstance.ProfileVI.MenuProfile.ProfileNameFrame.ProfileNameLastNameTextBox.LastNameTextValue,
        FirstName: viewInstance.ProfileVI.MenuProfile.ProfileNameFrame.ProfileNameFirstNameTextBox.FirstNameTextValue,
        BioDOB: viewInstance.ProfileVI.MenuProfile.ProfileDateofBirthFrame.DateofBirthTextValue,
        BioGender: bgender,
        BioRace: race,
        Email: viewInstance.ProfileVI.MenuProfile.ProfileEmailFrame.EmailTextValue,
        SpokenLanguageID: language,
        EducationLevelGuid: educationGuid,
        ZipCode: zipcode,
        CountryCode: country,
        ParticipantAddressGuid: viewInstance.ProfileVI.MenuProfile.ProfileAddressFrame.AddressSQL[0].PersonAddressGuid,
        ParticipantAddressTypeGuid: viewInstance.ProfileVI.MenuProfile.ProfileAddressFrame.AddressSQL[0].AddressTypeGuid,
        validLastName: validateLastName(viewInstance.ProfileVI.MenuProfile.ProfileNameFrame.ProfileNameLastNameTextBox.LastNameTextValue),
        validFirstName: validateFirstName(viewInstance.ProfileVI.MenuProfile.ProfileNameFrame.ProfileNameFirstNameTextBox.FirstNameTextValue),
        validDoB: validateDoB(viewInstance.ProfileVI.MenuProfile.ProfileDateofBirthFrame.DateofBirthTextValue),
        validGender: validateGender(viewInstance.ProfileVI.MenuProfile.ProfileGenderFrame.GenderTextValue),
        validRace: validateRace(race),
        validEmail: validateEmail(viewInstance.ProfileVI.MenuProfile.ProfileEmailFrame.EmailTextValue),
        validSpokenLanguage: validateSpokenLanguage(language),
        validEducation: validateEducation(educationGuid),
        validZipCode: validateZipCode(zipcode),
        validCountry: validateCountry(country),
      })
    }

  }, [viewInstance, settings])

  const saveProfile = () => {
    let saveData = paramData

    saveData = {
      ...saveData, LastName: sanitizeNull(paramData.LastName),
      FirstName: sanitizeNull(paramData.FirstName),
      BioDOB: sanitizeNull(paramData.BioDOB),
      BioGender: sanitizeNull(paramData.BioGender.GenderTypeId),
      BioRace: sanitizeNull(paramData.BioRace.RaceTypeId),
      SpokenLanguageID: sanitizeNull(paramData.SpokenLanguageID.LanguageTypeId),
      EducationLevelGuid: sanitizeNull(paramData.EducationLevelGuid.EducationTypeGuid),
      CountryCode: sanitizeNull(paramData.CountryCode.CountryId),
      ZipCode: sanitizeNull(paramData.ZipCode)
    }


    dispatch(updateProfileDemographics({ "ParamData": saveData }));

    if (saveData.ParticipantAddressGuid.length) {
      //update
      let addressUpdateString = "" + saveData.AuthToken + '/' +
        saveData.ParticipantAddressGuid + "/" +
        saveData.ParticipantAddressTypeGuid + "/" +
        "~_~/~_~/~_~/~_~/~_~/~_~/" +
        saveData.ZipCode + "/" +
        saveData.CountryCode + "/"

      dispatch(updateProfileAddress(addressUpdateString))
    } else {
      //create, but only if there's data there to create
      if (paramData.ZipCode || paramData.CountryCode.CountryId) {
        let addressCreateString = "" + saveData.AuthToken + '/' +
          saveData.ParticipantGuid + "/" +
          "90899741-5728-4F9C-A489-691131304962/" +
          "~_~/~_~/~_~/~_~/~_~/~_~/" +
          saveData.ZipCode + "/" +
          saveData.CountryCode + "/"

        dispatch(createProfileAddress(addressCreateString))
      }
    }
    setCallVI(false)

    return
  }

  const validateFirstName = (name) => {
    if (!name && settings.organization["REQUIRE NAME FIRST"] === "0") {
      paramData.validFirstName = true;
    }
    else if (!(/^[\p{L} ,.'-]+$/u).test(name)) {
      paramData.validFirstName = false;
    }
    else {
      paramData.validFirstName = true;
    }
    return paramData.validFirstName;
  }
  const validateLastName = (name) => {
    if (!name && settings.organization["REQUIRE NAME LAST"] === "0") {
      paramData.validLastName = true;
    }
    else if (!(/^[\p{L} ,.'-]+$/u).test(name)) {
      paramData.validLastName = false;
    }
    else {
      paramData.validLastName = true;
    }
    return paramData.validLastName;
  }
  const validateEmail = (name) => {
    if (!name && settings.organization["REQUIRE EMAIL"] === "0") {
      paramData.validEmail = true;
    }
    else if (!(/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/u).test(name)) {
      paramData.validEmail = false;
    }
    else {
      paramData.validEmail = true;
    }
    return paramData.validEmail;
  }
  const validateDoB = (name) => {
    let currentTime = new Date().getTime();
    let birthDateTime = new Date(name).getTime();
    let difference = (currentTime - birthDateTime);
    var ageInYears = difference / (1000 * 60 * 60 * 24 * 365);

    let InvalidTooYoung = false;
    let InvalidTooOld = false;

    if (ageInYears < settings.organization["AGE MIN"]) {
      InvalidTooYoung = true;
    }
    if (ageInYears > settings.organization["AGE MAX"]) {
      InvalidTooOld = true;
    }

    if (isNaN(ageInYears) && settings.organization["REQUIRE DOB"] === "0") {
      paramData.validDoB = true;
    }
    else if (InvalidTooOld || InvalidTooYoung || isNaN(ageInYears)) {
      paramData.validDoB = false;
    }
    else {
      paramData.validDoB = true;
    }
    return paramData.validDoB;
  }

  const validateRace = (name) => {
    if (!name && settings.organization["REQUIRE RACE"] === "0") {
      paramData.validRace = true;
    }
    else if (!name) {
      paramData.validRace = false;
    }
    else {
      paramData.validRace = true;
    }
    return paramData.validRace;
  }

  const validateGender = (name) => {
    if (!name && settings.organization["REQUIRE GENDER"] === "0") {
      paramData.validGender = true;
    }
    else if (!name) {
      paramData.validGender = false;
    }
    else {
      paramData.validGender = true;
    }
    return paramData.validGender;
  }

  const validateEducation = (name) => {
    if (!name && settings.organization["REQUIRE EDUCATION"] === "0") {
      paramData.validEducation = true;
    }
    else if (!name) {
      paramData.validEducation = false;
    }
    else {
      paramData.validEducation = true;
    }
    return paramData.validEducation;
  }

  const validateSpokenLanguage = (name) => {
    if (!name && settings.organization["REQUIRE LANGSPEAK"] === "0") {
      paramData.validSpokenLanguage = true;
    }
    else if (!name) {
      paramData.validSpokenLanguage = false;
    }
    else {
      paramData.validSpokenLanguage = true;
    }
    return paramData.validSpokenLanguage;
  }

  const validateCountry = (name) => {
    if (!name && settings.organization["REQUIRE COUNTRY"] === "0") {
      paramData.validCountry = true;
    }
    else if (!name) {
      paramData.validCountry = false;
    }
    else {
      paramData.validCountry = true;
    }
    return paramData.validCountry;
  }

  const validateZipCode = (name) => {
    if (!name && settings.organization["REQUIRE ZIP"] === "0") {
      paramData.validZipCode = true;
    }
    else if (!name) {
      paramData.validZipCode = false;
    }
    else {
      paramData.validZipCode = true;
    }
    return paramData.validZipCode;
  }
  // used to readjust default validation values.


  const changeDelay = (change) =>{
    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }
    setTimer(
      setTimeout(() => {
        console.log(change);
      }, 500)
    );
}

  const sanitizeNull = (val) => {
    if (!val || val === -1) {
      return "~_~"
    } return val
  }

  return (
    <div>


      <Grid container direction={"row"} spacing={2} mb={2}>


        <Grid item xs={12}>
          <Typography variant="h6">{viewInstance.ProfileVI.MenuProfile.ProfileText.EmailHeader}</Typography>
        </Grid>
        <Grid item md={12} xs={12}>
          <TextField id="email" fullWidth size='small'
          autoComplete = "email"
            inputProps={{ pattern: "^[^\s@]+@([^\s@.,]+\.)+[^\s@.,]{2,}$", autocomplete: 'email' }}
            label={viewInstance.ProfileVI.MenuProfile.ProfileEmailFrame.EmailText}
            value={paramData.Email || null}
            error={!paramData.validEmail}
            helperText={paramData.validEmail ? '' : EmailError && EmailError.length > 0 && EmailError[0].MessageTypeContent}
            required={viewInstance.ProfileVI.MenuProfile.ProfileEmailFrame.EmailRequiredFlag === "1"}
            disabled={viewInstance.ProfileVI.MenuProfile.ProfileEmailFrame.EmailReadOnlyFlags === "1"}
            onChange={(e) => { setParamData({ ...paramData, Email: e.target.value }) }}
            onBlur={(e) => { setParamData({ ...paramData, validEmail: validateEmail(e.target.value) }) }}
          />

        </Grid>
        <Grid item xs={12}>
          <Typography variant="h6">{viewInstance.ProfileVI.MenuProfile.ProfileText.NameHeader}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid container direction={"row"} spacing={2}>

            <Grid item md={6} xs={12}>
              <TextField id="first-name" fullWidth size='small'
              autoComplete = "given-name"
                label={viewInstance.ProfileVI.MenuProfile.ProfileNameFrame.ProfileNameFirstNameTextBox.FirstNameText}
                value={paramData.FirstName || null}
                error={!paramData.validFirstName}
                helperText={paramData.validFirstName ? '' : FirstNameError && FirstNameError.length > 0 && FirstNameError[0].MessageTypeContent}
                required={viewInstance.ProfileVI.MenuProfile.ProfileNameFrame.ProfileNameFirstNameTextBox.FirstNameRequiredFlag === "1"}
                disabled={viewInstance.ProfileVI.MenuProfile.ProfileNameFrame.ProfileNameFirstNameTextBox.FirstNameReadOnlyFlag === "1"}
                onChange={(e) => { setParamData({ ...paramData, FirstName: e.target.value, validFirstName: validateFirstName(e.target.value) }) }}
                onBlur={(e) => { setParamData({ ...paramData, validFirstName: validateFirstName(e.target.value) }) }}
                inputProps={{
                  autocomplete: 'given-name'
                }}
              />
            </Grid>
            <Grid item md={6} xs={12} sx={{ display: viewInstance.ProfileVI.MenuProfile.ProfileNameFrame.ProfileNameLastNameTextBox.LastNameVisibleFlag === "0" ? "none" : "" }}>
              <TextField id="last-name" fullWidth size='small'
              autoComplete = "family-name"
                label={viewInstance.ProfileVI.MenuProfile.ProfileNameFrame.ProfileNameLastNameTextBox.LastNameText}
                value={paramData.LastName || null}
                error={!paramData.validLastName}
                helperText={paramData.validLastName ? '' : LastNameError && LastNameError.length > 0 && LastNameError[0].MessageTypeContent}
                required={viewInstance.ProfileVI.MenuProfile.ProfileNameFrame.ProfileNameLastNameTextBox.LastNameRequiredFlag === "1"}
                disabled={viewInstance.ProfileVI.MenuProfile.ProfileNameFrame.ProfileNameLastNameTextBox.LastNameReadOnlyFlag === "1"}
                onChange={(e) => { setParamData({ ...paramData, LastName: e.target.value, validLastName: validateLastName(e.target.value)  }) }}
                onBlur={(e) => { setParamData({ ...paramData, validLastName: validateLastName(e.target.value) }) }}
                inputProps={{
                  autocomplete: 'family-name'
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h6">{viewInstance.ProfileVI.MenuProfile.ProfileText.PersonalHeader}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid container direction={"row"} spacing={2}>
            <Grid item md={6} xs={12} >
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='en'>
                <DatePicker
                  label={viewInstance.ProfileVI.MenuProfile.ProfileDateofBirthFrame.DateofBirthLabel}
                  value={paramData.BioDOB}
                  disabled={viewInstance.ProfileVI.MenuProfile.ProfileDateofBirthFrame.DateofBirthReadOnlyFlag === "1"}
                  required={viewInstance.ProfileVI.MenuProfile.ProfileDateofBirthFrame.DateofBirthRequiredFlag === "1"}
                  format="MM-DD-YYYY"
                  onChange={(newValue) => {
                    setParamData({ ...paramData, BioDOB: dayjs(newValue).format('MM-DD-YYYY'), validDoB: validateDoB(dayjs(newValue).format('MM-DD-YYYY')) });
                  }}

                  onBlur={(newValue) => { setParamData({ ...paramData, BioDOB: dayjs(newValue).format('MM-DD-YYYY'), validDoB: validateDoB(dayjs(newValue).format('MM-DD-YYYY')) }) }}
                  renderInput={(params) => <TextField
                    {...params}
                    error={!paramData.validDoB}
                    size='small'
                    fullWidth
                    autoHighlight={false}
                    helperText={paramData.validDoB ? '' : DobError && DobError.length > 0 && DobError[0].MessageTypeContent
                      //  'Date of birth is invalid or age is outside of accepted range of '+settings.organization["AGE MIN"]+'-'+settings.organization["AGE MAX"]+'.'
                    } />}
                  disableFuture
                />
              </LocalizationProvider>

            </Grid>
            <Grid item md={6} xs={12}>
              <Autocomplete
                value={paramData.EducationLevelGuid || null}
                options={viewInstance.ProfileVI.MenuProfile.ProfileEducationFrame.EducationList}
                getOptionLabel={(option) => option.EducationTypeName}
                isOptionEqualToValue={(option, value) => { return option.EducationTypeGuid === value.EducationTypeGuid }}
                onChange={(e, newValue) => { setParamData({ ...paramData, EducationLevelGuid: newValue, validEducation: validateEducation(newValue) }) }}
                size="small"
                renderInput={(params) => <TextField {...params} 
                  label={viewInstance.ProfileVI.MenuProfile.ProfileEducationFrame.EducationLabel} 
                  required={viewInstance.ProfileVI.MenuProfile.ProfileEducationFrame.EducationRequiredFlag === "1"}
                  />}
                inputProps={{ autocomplete: 'education-dropdown' }}
                autoHighlight={false}
              />


            </Grid>
            <Grid item md={6} xs={12}>
              <Autocomplete
                value={paramData.BioGender || null}
                options={viewInstance.ProfileVI.MenuProfile.ProfileGenderFrame.ProfileGenderLabels}
                getOptionLabel={(option) => option.GenderTypeName}
                getOptionSelected={(option, value) => {
                  if (value) {
                    return true;
                  } else if (value === option) {
                    return true;
                  }
                }}
                isOptionEqualToValue={(option, value) => { return option.GenderTypeId === value.GenderTypeId }}
                size="small"
                renderInput={(params) => <TextField {...params} label={viewInstance.ProfileVI.MenuProfile.ProfileGenderFrame.GenderLabel}
                  
                    required={ viewInstance.ProfileVI.MenuProfile.ProfileGenderFrame.GenderRequiredFlag === "1"}
                  
                />}
                inputProps={{ autocomplete: 'sex-dropdown' }}
                onChange={(e, newValue) => { setParamData({ ...paramData, BioGender: newValue, validGender: validateGender(newValue) }) }}
                autoHighlight={false}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <Autocomplete
                options={viewInstance.ProfileVI.MenuProfile.ProfileLangSpeakFrame.LangSpeakDropdownList}
                getOptionLabel={(option) => option.StandardContent}
                autoHighlight={false}
                value={paramData.SpokenLanguageID || null}
                isOptionEqualToValue={(option, value) => { return option.SpokenLanguageID === value.SpokenLanguageID }}
                renderInput={(params) => <TextField
                  {...params}
                  label={viewInstance.ProfileVI.MenuProfile.ProfileLangSpeakFrame.LangSpeakLabel}

                  required={viewInstance.ProfileVI.MenuProfile.ProfileLangSpeakFrame.LangSpeakRequiredFlag === "1" }
                />}
                inputProps={{ autocomplete: 'language-dropdown' }}
                size="small"
                onChange={(e, newValue) => { setParamData({ ...paramData, SpokenLanguageID: newValue, validSpokenLanguage: validateSpokenLanguage(newValue) }) }}

              />
            </Grid>
            <Grid item md={6} xs={12}>
              <Autocomplete
                options={viewInstance.ProfileVI.MenuProfile.ProfileRaceFrame.ProfileRaceLabels}
                getOptionLabel={(option) => option.RaceTypeName}
                isOptionEqualToValue={(option, value) => { return option.RaceTypeID === value.RaceTypeID }}

                autoHighlight={false}
                value={paramData.BioRace || null}
                renderInput={(params) => <TextField {...params} label={viewInstance.ProfileVI.MenuProfile.ProfileRaceFrame.RaceLabel}
                required={ viewInstance.ProfileVI.MenuProfile.ProfileRaceFrame.RaceRequiredFlag === "1"}
                />}
                onChange={(e, newValue) => { setParamData({ ...paramData, BioRace: newValue, validRace: validateRace(newValue) }) }}
                size="small"
                inputProps={{
                  autocomplete: 'race-dropdown'
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h6">{viewInstance.ProfileVI.MenuProfile.ProfileText.AddressHeader}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid container direction={"row"} spacing={2}>
            <Grid item md={6} xs={12}>
              <Autocomplete
                options={viewInstance.ProfileVI.MenuProfile.ProfileAddressFrame.ProfileAddressCountryFrame.CountryDropdownList}
                getOptionLabel={(option) => option.StandardContent}
                isOptionEqualToValue={(option, value) => { return option.CountryCode === value.CountryCode }}
                autoHighlight={false}
                autoSelect
                value={paramData.CountryCode || null}
                renderInput={(params) => <TextField {...params} autoComplete="off" label={viewInstance.ProfileVI.MenuProfile.ProfileAddressFrame.ProfileAddressCountryFrame.CountryText} />}
                onChange={(e, newValue) => { setParamData({ ...paramData, CountryCode: newValue, validCountry: validateCountry(newValue) }) }}
                size="small"
                inputProps={{
                  autoComplete: 'off'
                }}
              />

            </Grid>
            <Grid item md={6} xs={12}>
              <TextField fullWidth
                label={viewInstance.ProfileVI.MenuProfile.ProfileAddressFrame.ProfileAddressZipcodeFrame.ZipcodeText}
                required={viewInstance.ProfileVI.MenuProfile.ProfileAddressFrame.ProfileAddressZipcodeFrame.ZipcodeRequiredFlag === "1"}
                value={paramData.ZipCode || null}
                onChange={(e) => { setParamData({ ...paramData, ZipCode: e.target.value, validZipCode: validateZipCode(e.target.value) }) }}
                size="small"
                inputProps={{
                  autocomplete: 'postal-code'
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={4}>
          <Button fullWidth variant="contained"
            disabled={!(
              paramData.validCountry &&
              paramData.validDoB &&
              paramData.validFirstName &&
              paramData.validLastName &&
              paramData.validRace &&
              paramData.validEducation &&
              paramData.validEmail &&
              paramData.validZipCode &&
              paramData.validGender &&
              paramData.validSpokenLanguage

            )}
            onClick={() => saveProfile()}>{viewInstance.ProfileVI.MenuProfile.SaveButton}</Button>

        </Grid >



      </Grid>


    </div>
  );


};

export default ProfileDemographics;